function runWhenInit() {
    //console.log("The current cart state is: ", window.liquidAjaxCart.cart);
  }
  
  if (window.liquidAjaxCart?.init) {
    // if Liquid Ajax Cart is already initialized
    runWhenInit();
  } else {
    // wait for Liquid Ajax Cart to be initialized
    document.addEventListener("liquid-ajax-cart:init", runWhenInit);
  }



// Listen for the "liquid-ajax-cart:request-end" event which is fired
// after a Shopify Cart API Ajax request is performed
document.addEventListener('liquid-ajax-cart:request-end', event => {
    const {requestState} = event.detail;
    const {sections} = event.detail;
    //console.log("Sections are re-rendered: ", sections);
  
    // If the "add to cart" request is successful
    if (requestState.requestType === 'add' && requestState.responseData?.ok) {
  
      // Add the CSS class to the "body" tag
      document.body.classList.add('js-my-cart-open');
      //console.log("Cart is open");
    }
  });

  // Add a special CSS class when the cart-icon is clicked 
document.querySelector("#cart-icon-bubble").addEventListener("click", function(e){
    //prevent default
    e.preventDefault();
    document.body.classList.toggle("js-my-cart-open");
  });


  document.querySelector(".side-cart-container").addEventListener("click", function(e){
    //prevent default
    e.preventDefault();
    document.body.classList.remove("js-my-cart-open");
  });

  document.querySelector("#side-cart-close-button").addEventListener("click", function(e){
    //prevent default
    e.preventDefault();
    document.body.classList.remove("js-my-cart-open");
  });
